import { combineReducers } from "redux";
import { reducer as identity } from "./identity";
import { reducer as savedItems } from "./savedItems";
import { reducer as analytics } from "./analytics";
import { reducer as similarItems } from "./similarItems";
import { reducer as common } from "./common";
import { reducer as backInStock } from "./backInStock";
import { reducer as loyalty } from "./loyalty";

export default combineReducers({
  identity,
  savedItems,
  analytics,
  similarItems,
  common,
  backInStock,
  loyalty
});
